// 智能诊股 首页
<template>
  <div class="main">
    <div class="bd bg clearfix">
      <div class="inputbox1">
        <div
          type="text"
          class="inp1"
          placeholder="请输入您要诊断的股票代码或名称"
          @click="showSeacherPage"
        >
        请输入您要诊断的股票代码或名称
        </div>
      </div>
      <div class="searchHd">
        <div class="inputbox2">
          <!--<form action="">--> 
            <i class="i-search"></i
            ><input
              v-model.trim="input_value"
              type="text"
              class="inp2"
              ref="inp2"
              placeholder=" 请输入您要诊断的股票代码或名称"
            />
          <!--</form>-->
          <button class="i-delete" v-show="input_value.length" @click="iptnull"></button>
        </div>
        <button class="i-cancel" @click="goIndex">取消</button>
      </div>

      <ul
        class="historyBox"
        v-show="
          input_value === '' &&
          pageType === 'seacher' &&
          list.length === 0 &&
          historyData.length != 0
        "
      >
        <li
          v-for="(item, index) in historyData"
          :key="index"
          @click="gotoDetail(item.symbol,item.name)"
        >
          <a href="javascript:;"
            ><i class="icon-time"></i> <span v-html="item.name"></span> </a
          ><button
            @click.stop="removeLS(item)"
            class="i-delete2"
            :data-symbol="item.symbol"
          ></button>
        </li>
      </ul>

      <ul class="searchBox" v-show="list.length != 0">
        <li
          v-for="(item, index) in list"
          :key="index"
          :data-symbol="item.symbol"
          @click="saveLS(item)"
        >
          <a href="javascript:;"
            ><i class="label"
              >{{ item.label}}</i
            ><span class="stockcode">{{ item.code }}</span
            ><span class="stockname" v-html="item.name"></span
          ></a>
        </li>
      </ul>
      <div class="content">
        <p>
          智能诊股基于大数据挖掘，自动分析海量交易数据和股票资讯，将关键信息提炼呈现。基于市场题材热度与板块轮动风向，捕捉短线资金聚集焦点。
        </p>
        <p>
          通过筛选最新的研报，通过大数据算法对股票进行评级，并指出压力位、支撑位，分别给出短线、中长线建议。对你关心的股票作出专业而全面的诊断；
        </p>

        <!-- 轮播 智能诊股记录 swiper-no-swiping 禁止手动滑动 -->
        <div class="top-stock-list-wrap" v-if="top_list.length > 0">
            <div class="top-stock-list swiper2">
                <div class="swiper-container">
                    <div class="swiper-wrapper swiper-no-swiping">
                        <div
                            class="swiper-slide"
                            v-for="(item, i) in top_list"
                            :key="'ing_' + i"
                        >
                        <span class="top-stock-list-item"
                            :data-stock="item.code"
                            :data-name="item.stock_name"
                            @click="gotoDetail(item.code,item.stock_name)"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.90202 0.362742L4.10495 2.60062V9.72113L7.90202 11.959C8.62038 12.3659 9.23612 12.0607 9.23612 11.2469V1.0748C9.23612 0.261032 8.62038 -0.145855 7.90202 0.362742ZM0 4.12645V8.1953C0 9.00907 0.718362 9.72113 1.53935 9.72113H3.07871V2.60062H1.53935C0.718362 2.60062 0 3.31267 0 4.12645ZM13.1236 0.99485C12.9194 1.30863 13.0089 1.73066 13.3211 1.93729C13.3948 1.98595 15.1387 3.17603 15.1387 6.13839C15.1387 9.10731 13.4658 10.2985 13.3992 10.3439C13.0859 10.5532 13.0018 10.9758 13.2103 11.2896C13.3413 11.4864 13.5575 11.593 13.7775 11.593C13.9068 11.593 14.0384 11.5553 14.1546 11.4782C14.2501 11.4148 16.5 9.8699 16.5 6.13784C16.5 2.39868 14.159 0.854905 14.0591 0.790946C13.7452 0.589228 13.3288 0.681067 13.1236 0.99485ZM11.0418 3.11371C10.8792 3.44936 11.02 3.85553 11.3529 4.02335C11.3961 4.04577 12.4156 4.57658 12.4156 6.08809C12.4156 7.70293 11.4621 8.23811 11.4304 8.25561C11.0942 8.42398 10.9578 8.83397 11.1259 9.17072C11.246 9.41016 11.4856 9.54791 11.7361 9.54791C11.8382 9.54791 11.9424 9.52495 12.0396 9.4763C12.1105 9.44022 13.7769 8.5765 13.7769 6.08809C13.7769 3.68716 12.0145 2.8289 11.9397 2.79337C11.604 2.63429 11.205 2.77915 11.0418 3.11371Z" fill="url(#paint0_linear_16204_49713)"/>
                          <defs>
                            <linearGradient id="paint0_linear_16204_49713" x1="0" y1="0.138428" x2="0" y2="12.1384" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#DEEFFF"/>
                              <stop offset="1" stop-color="#4EBBFF"/>
                            </linearGradient>
                          </defs>
                        </svg>
                          <span class="span">
                            {{ item.describe }}
                          </span>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <img
          src="https://cdncos.aigupiao.com/assets/pc/img/2023/znzg_index_19.svg"
          alt=""
        />

        <p class="jsy">智能诊股结果仅供参考，不构成任何投资建议。股市有风险，投资决策需谨慎，操作风险自担。</p>



      </div>
    </div>
  </div>
</template>

<script>

import Swiper from "swiper";
import "swiper/css/swiper.min.css";

import zhenGuApi from "@/api/Intelligent_diagnosis_stock/index";
import "@/utils/flexible";

export default {
  data() {
    return {
      pageType: "index",
      input_value: "",
      list: [],
      historyData: [],

      //智能诊股记录
      top_list:[],
      swiper2:null,
      cureentDefault: "", // 环境

      timer:null,
      appDomain:'https://app.aigupiao.com',
    };
  },

  created() {
    $(".main,body").css("background", "linear-gradient(90deg, #253E5B 0%, #142C4A 100%)");
    this.$nextTick(() => {
      //this.init();
    });

    this.historyData = localStorage.hasOwnProperty("agp_xn_s2")
      ? JSON.parse(localStorage.getItem("agp_xn_s2"))
      : [];
    //console.log(this.historyData);


    let _host = location.host, _currentDefault;
    if(_host.indexOf("dev") > -1 || _host.indexOf("192") > -1) {
        _currentDefault = "dev"
    } else if(_host.indexOf("beta") > -1) {
        _currentDefault = "beta"
    } else {
        _currentDefault = ""
    }

    this.cureentDefault = _currentDefault;
    this.getTopData();
  },
    updated(){
      $('.stockname .highlight').css("color","#fe484a");
    },
  methods: {
    swiper(){
        //智能诊股 滚动事件
        if(this.swiper2){
            //清楚 已有滚动
            this.swiper2.destroy(true);
        }
        if(this.top_list.length > 1){
            this.$nextTick(() => {
                this.swiper2 = new Swiper(".swiper-container", {
                    autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        loop: true,
                        direction: 'vertical',
                });
            });
        }
    },
    getTopData(){
      let _this = this;
      //股票池战绩榜轮播信息
      //apidev.aigupiao.com/goapi/znzg/get_buy_record
      $.ajax({ xhrFields: {withCredentials: true},
          type: 'get',
          dataType: 'json',
          url: `https://api${_this.cureentDefault}.aigupiao.com/goapi/znzg/get_buy_record`,
          cache: false,
          async: true,
          error: function(){return false;},
          success:function(res){
              console.info(res,'__-rse2')
              if(res.data && res.data.length > 0){
                _this.top_list = res.data;
                _this.swiper();
              }
              // else{
              //   //测试
              //   _this.top_list = [
              //     {
              //       "code":"sh600009",
              //       "describe":"红***刚刚诊断了上海机场，该股票综合评分的的的的的的为**...",
              //       "stock_name":"上海机场",
              //       "user_id":24
              //     },
              //     {
              //       "code":"sh600001",
              //       "describe":"ddd***刚刚诊断了上海机场，该股票综合评分为**...",
              //       "stock_name":"sdfsf",
              //       "user_id":24
              //     },
              //   ]
              //   _this.swiper();

              // }

          }
      })
    },
    async stockSearch(k) {
      const data = await zhenGuApi.stockSearch2(k);
      let _list = data.data;
      console.log(_list,'_list')
      _list = _list.fliter(item.kind != 'BK');
      _list = _list.map((item)=>{
        item.code = item.c;
        item.kind = item.kind;
        item.name = item.n;
        item.symbol = item.s;

        return item;
      })


      this.list = _list;




      console.log(this.list);
    },

    goIndex() {
      this.pageType = "index";
      this.input_value = "";
      this.list = [];

      $(".bd").addClass("bg");
      $(".content").show();
      $(".inputbox1").show();
      $(".searchHd").hide();
      $(".main,body").css("background", "linear-gradient(90deg, #253E5B 0%, #142C4A 100%)");
    },

    iptnull() {
      this.input_value = "";
      this.list = [];
    },

    // 去重
    unique(arr, item) {
      let result = {};
      let finalResult = [];
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].name] = arr[i];
      }
      for (item in result) {
        finalResult.push(result[item]);
      }
      return finalResult;
    },
    //
      deleteItem(array,item) {
          for(let i = 0;i<array.length;i++){
              if(array[i].symbol == item.symbol ){
                  array.splice(i, 1);
              }
          }
      },
      removeLS(item) {
      const data = {
        name:  $('<p>'+item.name+'</p>').text(),
        symbol: item.symbol,
      };

      this.historyData = this.unique(this.historyData, data);
      this.deleteItem(this.historyData,data);
      console.log(this.historyData);

      localStorage.setItem("agp_xn_s2", JSON.stringify(this.historyData));
    },
    // 存储历史
    saveLS(item) {
      const data = {
        name:  $('<p>'+item.name+'</p>').text(),
        symbol: item.symbol,
      };

      this.historyData.unshift(data);

      this.historyData = this.unique(this.historyData, data);

      localStorage.setItem("agp_xn_s2", JSON.stringify(this.historyData));

      this.gotoDetail(item.symbol,item.name);
    },
    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 跳转到诊股
    gotoDetail(symbol,name) {
      // http://192.168.1.63:8080/up/Intelligent_diagnosis_stock/symbol/600009/uid/44324/name/%E4%B8%8A%E6%B5%B7%E6%9C%BA%E5%9C%BA/
      if(location.href.indexOf("u_id=")>-1){
        var u_id = this.getQueryVariable('u_id');
        var name = $('<p>'+name+'</p>').text();
        let is_from_agq = '';
        if(location.href.includes('is_from_agq=yes')){
          is_from_agq = 'is_from_agq'
        }
        if(location.href.includes('is_from_kd=yes')){
          is_from_agq = 'is_from_kd'
        }
        if(location.href.includes('is_from_zf=yes')){
          is_from_agq = 'is_from_zf'
        }
        if(typeof symbol == 'string'){
          symbol = symbol.replace(/[^0-9]/ig, "");
        }
        location.href = "/up/Intelligent_diagnosis_stock/symbol/"+symbol+"/uid/"+u_id+"/name/"+encodeURI(name)+"/"+is_from_agq;
      }
      else{
        alert("当前未登录！")
      }
    },

    showSeacherPage() {
      $(".main").css("background", "#F5F5F5");
      $(".bd").removeClass("bg");

      $(".content").hide();
      $(".inputbox1").hide();

      $(".searchHd").show();
      this.pageType = "seacher";

      this.$nextTick(()=>{
        $(".inp2").focus();
        this.$refs['inp2'].focus();

        setTimeout(()=>{
          $(".inp2").focus();
          this.$refs['inp2'].focus();

          setTimeout(()=>{
            $(".inp2").focus();
            this.$refs['inp2'].focus();
          }, 200)
        }, 200)
      })
    },

    // init() {
    //   var _self = this;
    //   // $(function() {

    //   // var u_id = location.search.substr(6);

    //   // $("body").on("click", ".i-delete", function() {
    //   //   $(".inp2").val("");
    //   //   // $(".searchBox").hide()
    //   // });

    //   var flag2 = true;
    //   $(".inp2").on("compositionstart", function() {
    //     flag2 = false;
    //   });
    //   $(".inp2").on("compositionend", function() {
    //     flag2 = true;
    //   });
    //   // $('.inp2').on('mouseup',function(){
    //   //     // $(".searchBox").show()
    //   // })
    //   $(".inp2").bind("input porpertychange", function() {
    //     //搜索框
    //     // $('.searchBox').hide();
    //     setTimeout(function() {
    //       if (flag2) {
    //         //搜索股票

    //         // var __url = "/calf/search?keyword="+input_value;
    //         if (_self.input_value != "") {
    //           _self.stockSearch(_self.input_value);
    //         } else {
    //           _self.list = [];
    //         }
    //       }
    //     }, 500);
    //   });

    //   // });
    // },
    // 搜索
    ssFn(keyword) {
      //var url = `${WWW_AIGUPIAO_COM}/Api/Search/search?type=NewAll&page=0&position=1`;
      // var url = `${WWW_AIGUPIAO_COM}/Api/Search/search?type=PCDH&page=0&position=1`;

      // if (this.jqReq !== null) {
      //   // 终止前面发出的请求 防止前面的请求后返回
      //   this.jqReq.abort();
      // }
      // this.loading = true;
      
      this.ssFnStock(keyword);
      
      // this.jqReq = $.getJSON(
      //   url,
      //   {
      //     md,
      //     keyword
      //   },
      //   d => {
      //     this.data = d.data;
      //     this.number = d.number;
      //   }
      // ).complete(() => {
      //   this.loading = false;
      // });
    },
    ssFnStock(keyword){
      let _this = this;
      $.ajax({ xhrFields: {withCredentials: true},
          type: 'get',
          url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/search`,
          data:{
            keyword:keyword,
            page:1,
            number:20,
          },
          dataType: 'json',
          cache: false,
          async: true,
          beforeSend:function (XMLHttpRequest){},
          error: function(){return false;},
          success:function(data){
            if(data.code == 1){

              let _list = data.data;
              console.log(_list,'_list')
              if(_list.length > 0){
                _list = _list.filter((item) =>(item.kind != 'BK'));
                _list = _list.map((item)=>{
                  item.code = item.c;
                  item.kind = item.kind;
                  item.name = item.n;
                  item.symbol = item.s;

                  return item;
                })
                _this.list = _list;
              }
              else{
                _this.list = [];
              }



            }
            else{
              _this.list = [];
            }
          }
      })
    },
  },
  watch: {
    input_value(v) {
      if (v) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.ssFn(v);
        }, 500);
      } else {
        this.list = [];
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
/* *{margin:0; padding: 0} */
.main{
  line-height: 0!important;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.main {
  min-height: 100vh;
  background: linear-gradient(90deg, #253E5B 0%, #142C4A 100%);
}
.bar-nav {
  position: fixed;
  z-index: 10;
  right: 0;
  left: 0;
  top: 0;
  height: rem(10px);
  line-height: rem(10px);
  background-color: #fff;
  border-bottom: 1px solid #ececec;
  text-align: center;
}
.action-back {
  background: url("https://cdn.aigupiao.com/static/wap/img/invoice/arrow-l.png");
  background-size: cover;
  display: inline-block;
  width: rem(32px);
  height: rem(32px);
  position: absolute;
  left: rem(2px);
  top: rem(32px);
}
.bar-nav h1 {
  font-size: rem(34px);
}
/*body {
  font-size: rem(32px);
  background: #253d59;
  height: 100%;
}*/

.clearfix {
  zoom: 1;
  display: inline-block;
  display: block;
}
.clearfix:after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
}
.bd {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: rem(4px);
}
.bg {
/*  background: #253d59
    url("https://cdncos.aigupiao.com/assets/pc/img/stock_bg.png") 0 0;
  background-size: rem(374px);
  padding: 0 rem(24px);*/
  background: url(https://cdncos.aigupiao.com/assets/pc/img/stock_bg.png) no-repeat;
  background-size: 100% rem(374px);
  padding: 0 rem(24px);
}
.content {
  width: 100%;
}
.content p{
  color: #FFF;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  margin-bottom: 10px;
}
.content p.jsy{
  color: #FFFFFF80;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; 
  margin-bottom: 10px;
}

.content img {
  width: 100%;
  padding-bottom: 10px;
}
.inputbox1 {
  height: rem(120px);
  padding-top: rem(40px);
  box-sizing: content-box;
}
.inputbox1 .inp1,
.inputbox2 {
  border: none;
  background: #fff;
  height: rem(80px);
  line-height: rem(80px);
  border-radius: rem(40px);
  outline: none;
  box-sizing: border-box;
  padding: 0 rem(30px);
  font-size: rem(28px);
}
.inputbox1 .inp1 {
  width: 100%;
  text-align: center;
  color: rgba(117, 117, 117);
}
.searchHd {
  display: none;
  margin-top: rem(2px);
  padding: rem(24px);
  padding-top: rem(38px);
  width: 100%;
  box-sizing: border-box;
  height: rem(130px);
}
.inputbox2 {
  width: 82%;
  position: relative;
  float: left;
  overflow: hidden;
}

.inputbox2 .inp2 {
  height: 100%;
  line-height: 100%;
  width: 100%;
  outline: none;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  border: none;
  top: 0;
  bottom: 0;
  font-size: rem(28px);
  box-sizing: border-box;
  padding-left: 40px;
  background-color: transparent;
  caret-color: red;
}
.inputbox2 .i-search {
  display: inline-block;
  left: rem(30px);
  top: rem(24px);
  width: rem(30px);
  height: rem(30px);
  background: url("https://cdn.aigupiao.com/static/wap/img/xn-zg/i-search.png");
  background-size: cover;
  position: absolute;
}

.i-delete,
.i-delete2 {
  position: absolute;
  right: rem(30px);
  top: rem(24px);
  width: rem(30px);
  height: rem(30px);
  border: none;
  background: url("https://cdn.aigupiao.com/static/wap/img/xn-zg/i-delete.png");
  background-size: cover;
  display: inline-block;
  outline: none;
}
.i-delete2 {
  right: rem(30px);
  top: rem(36px);
  width: 10%;
  height: rem(40px);
    background: url("https://cdn.aigupiao.com/static/wap/img/xn-zg/i-delete.png") no-repeat;
    background-size:rem(30px) rem(30px) ;
    background-position: top center;

}
.i-cancel {
  display: inline-block;
  background: none;
  border: none;
  float: right;
  font-size: rem(30px);
  color: #ff645c;
  line-height: rem(80px);
  outline: none;
}
.historyBox {
  width: 100%;
}
.historyBox li {
  height: rem(80px);
  line-height: rem(80px);
  border-bottom: 1px solid #ccc;
}
.historyBox,
.searchBox {
  // display: none;
}
/*.stockname{
  opacity: 1;
}
.stockname >>> span.highlight {
  color: #fe484a!important;
}*/
.searchBox,
.historyBox {
  background: #fff;
}
.searchBox li,
.historyBox li {
  height: rem(50px);
  line-height: rem(50px);
  border-bottom: 1px solid #e9e9e9;
  padding: rem(24px);
  box-sizing: content-box;
}
.historyBox li {
  position: relative;
}
.searchBox li a,
.historyBox li a {
  color: #000;
  display: block;
  width: 100%;
  font-size: rem(30px);
}
.historyBox li a {
  //height: rem(100px);
  // line-height: rem(100px);
  display: block;
}
.icon-time {
  background: url("https://cdn.aigupiao.com/static/wap/img/xn-zg/i-time.png");
  background-size: cover;
  display: inline-block;
  width: rem(30px);
  height: rem(30px);
  margin-right: rem(20px);
  vertical-align: middle;
}
.label {
  width: rem(56px);
  text-align: center;
  height: rem(32px);
  line-height: rem(32px);
  border: 1px solid rgba(254, 72, 74, 1);
  border-radius: 3px;
  // font-size:rem(22px);
  color: rgba(254, 72, 74, 1);
  display: inline-block;
  font-style: normal;
  margin-right: rem(24px);
  padding: 2px;
  box-sizing: content-box;
}
.stockcode {
  display: inline-block;
  width: rem(200px);
}


.swiper2{
        width: 100%;
        height: 42px;
        line-height: 42px;
        margin-bottom: 10px;
        border-radius: 8px;
        border: 0.5px solid rgba(55, 122, 185, 0.50);
        background: linear-gradient(180deg, rgba(54, 121, 184, 0.50) 0%, rgba(31, 90, 146, 0.50) 100%);
        background-position: 100%;
}
.swiper2 .swiper-container{
    height: 100%;
}
.swiper2 .swiper-slide div{
    box-sizing: border-box;
    height: 100%;
    line-height: 200px;
    text-align: center;
    
}
.top-stock-list-item{
    padding-right: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #FFF;

    position: relative;
    display: flex;
    align-items: center;
}

.top-stock-list-item span{
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.top-stock-list-item svg{
  width: 16.5px;
  height: 12px;
  flex-shrink: 0;
  margin: 0 8px 0 12px;
}
</style>
